// extracted by mini-css-extract-plugin
export var address = "contact-module--address--ctwnX";
export var addressLink = "contact-module--address-link--I21Zr";
export var instagram = "contact-module--instagram--4hxd9";
export var page = "contact-module--page--FuOSY";
export var sectionRow = "contact-module--section-row--WC+Ja";